import { graphql, useStaticQuery } from 'gatsby'

/**
 * @property en_MY
 * @property es_CL
 * @property es_PE
 * @property pt_BR
 */
export const chartLevelsQuery = graphql`
  query chartLevelsQuery {
    en_MY: allMdx(
      filter: { fileAbsolutePath: { regex: "/en-my/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    es_CL: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-cl/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    es_MX: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-mx/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    es_CO: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-co/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    es_PE: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-pe/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    pt_BR: allMdx(
      filter: { fileAbsolutePath: { regex: "/pt-br/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
    es_EC: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-ec/chart-levels/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            order
            level
            percentF2F
            percentOnline
            hideValue
            onlyShowInOnlineSales
            onlineLabel
            F2FLabel
            currency
            color
          }
        }
      }
    }
  }
`

const useChartLevels = () => useStaticQuery(chartLevelsQuery)

export default useChartLevels
